import type { Job } from "@eai-toolkit/client";
import { JobState } from "@eai-toolkit/client";

export type LocalJob = Job & {
  startedOn?: string;
  endedOn?: string;
  elapsed?: number;
  gpu?: number;
  replicas?: number;
};

export function jobToLocalType(job: Job): LocalJob {
  const { runs } = job;
  const lastRun = runs && runs[runs.length - 1];
  let elapsed: number | undefined;
  if (lastRun && lastRun.startedOn) {
    const startDateTime = new Date(lastRun.startedOn).getTime();
    const runningOrCancellingStates: JobState[] = [
      JobState.RUNNING,
      JobState.CANCELLING,
    ];
    if (!lastRun.endedOn || runningOrCancellingStates.includes(job.state)) {
      elapsed = Date.now() - startDateTime;
    } else {
      const endDateTime = new Date(lastRun.endedOn).getTime();
      elapsed = endDateTime - startDateTime;
    }
  } else {
    elapsed = undefined;
  }
  return {
    ...job,
    startedOn: lastRun?.startedOn ?? undefined,
    endedOn: lastRun?.endedOn ?? undefined,
    elapsed,
    gpu: job.resources?.gpu,
    replicas: job.resources?.replicas,
  };
}
